import { UserGroups } from 'pages/TeamMembers/const'

export const AccountStatus = {
  ENABLED: 'ENABLED', // previously ACTIVE
  NOT_ENABLED: 'NOT_ENABLED', // previously INACTIVE
  SUSPENDED: 'SUSPENDED',
} as const

export type AccountStatus = keyof typeof AccountStatus

export interface AccountType {
  id: number
  name: string
  isCurrent: boolean
  reference: string
  status?: AccountStatus
}

export type UserGroupType = keyof typeof UserGroups

export interface AccountUserGroup {
  id: number
  name: UserGroupType
}

export interface AccountUser {
  id: number
  emailAddress: string
  groups: AccountUserGroup[]
  name?: string
  approver?: boolean
  isWorkspaceOwner?: boolean
}
